<obg-accordion [expanded]="expandedKeys">
	<span obgAccordionHeader test-id="licence-tab" [obgInteraction]="licensesTrackingData" [key]="licensesKey">
		<span>{{ "footer.licence.title" | translate }}</span>
		<span class="ico-chevron-down"></span>
	</span>
	<obg-accordion-content [key]="licensesKey" test-id="legal-content-text">
		<p test-id="licence-item" *ngFor="let license of licenses" [innerHTML]="license | translate"></p>
	</obg-accordion-content>
</obg-accordion>
